import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { selectLoan } from "@/store/selectors";
import { usePreScoringExperiment } from "@/helpers/usePreScoringExperiment";
import { LoanActionCreators } from "@/store/action-creators";
import {
  RUSSIAN_LOCALE,
  isCalculatorAvailable,
  isCalculatorSumAvailable,
} from "../../../helpers/const";
import { periodEndings } from "../../../helpers/helpers";

import { UiActionCreators } from "../../../store/action-creators/uiActions";
import { CalculatorButton } from "./CalculatorButton.tsx";

export const CalculatorPanel = ({ showButton, setShowCalcMobile }) => {
  const location = useLocation();

  const dispatch = useDispatch();

  const amounts = useSelector(selectLoan);

  const getSearchParams = (search) => {
    const params = new URLSearchParams(search);

    return {
      amount: params.get("amount"),
      term: params.get("term"),
      periodTypeId: params.get("periodTypeId"),
    };
  };

  const formatLoanTerm = (term, periodTypeId) =>
    `${term} ${periodEndings(term, periodTypeId)}`;

  const loanAmount = useMemo(() => {
    const { amount, term, periodTypeId } = getSearchParams(location.search);

    if (amount && term && periodTypeId) {
      return parseFloat(amount.replace(",", ".")).toLocaleString(
        RUSSIAN_LOCALE
      );
    }

    return amounts.loanAmount?.toLocaleString(RUSSIAN_LOCALE);
  }, [location.search, amounts.loanAmount]);

  const loanTerm = useMemo(() => {
    const { amount, term, periodTypeId } = getSearchParams(location.search);

    if (amount && term && periodTypeId) {
      return formatLoanTerm(Number(term), periodTypeId);
    }

    return formatLoanTerm(Number(amounts.term), String(amounts.periodTypeId));
  }, [location.search, amounts.term, amounts.periodTypeId]);

  const openCalculator = useCallback(() => {
    if (isCalculatorAvailable(location.pathname)) {
      dispatch(UiActionCreators.toggleSideBarCalculator());
    } else {
      dispatch(UiActionCreators.showSideBarCalculator(false));
    }
  }, [location.pathname]);

  const openCalculatorMobile = useCallback(() => {
    if (isCalculatorAvailable(location.pathname)) {
      setShowCalcMobile((showCalcMobile) => !showCalcMobile);
    } else {
      setShowCalcMobile(false);
    }
  }, [location.pathname]);

  const isPreScoringExperiment = usePreScoringExperiment();

  useEffect(() => {
    const { amount, term, periodTypeId } = getSearchParams(location.search);

    if (amount && term && periodTypeId) {
      dispatch(LoanActionCreators.setTermAmount(Number(term)));
      dispatch(LoanActionCreators.setPeriodType(periodTypeId));
      dispatch(
        LoanActionCreators.setLoanAmount(parseFloat(amount.replace(",", ".")))
      );
    }
  }, [location.search]);

  if (
    isPreScoringExperiment &&
    location.pathname.includes("/new_application-timer")
  ) {
    return null;
  }

  return (
    <div className="header-calc-title">
      {isCalculatorSumAvailable(location.pathname) && (
        <>
          <div className="header-calc-title-in">
            <span>Вы берете займ на сумму:</span>
            <b>{loanAmount} ₽</b>
          </div>
          <div className="header-calc-title-in">
            <span>Сроком на:</span>
            <b>{loanTerm}</b>
          </div>
        </>
      )}

      {isCalculatorAvailable(location.pathname) && (
        <div className="position-relative">
          <CalculatorButton
            className="calc-btn"
            visible={showButton}
            onClick={openCalculator}
          />
          <CalculatorButton
            className="calc-btn-mobile"
            visible={showButton}
            onClick={openCalculatorMobile}
          />
        </div>
      )}
    </div>
  );
};
